import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { VTableRowStatus } from "../../../_enums/VTableRowStatus.enum";
import './status-cell.component.scss';

@Component({
    selector: 'status-cell',
    template: require('./status-cell.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusCell {
    @Input() data: VTableRowStatus;
    @Input() classes: string;

    VTableRowStatus = VTableRowStatus;

    constructor() { }

    ngOnInit() {
    }
}
